module.exports = __webpack_public_path__ + "mastercard-icon@3x.png?e310dcad9651823f4a33bfc90850baf6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mastercard-icon@3x.png
// module id = 1042
// module chunks = 0